import React, { useEffect, useState } from "react";
import Text from "antd/lib/typography/Text";
import { Button, Image, Progress } from "antd";
import styles from "../../styles/dashboard.module.scss";

function OverallResult({ overallLevel }: any) {
  useEffect(() => {
    console.log(overallLevel?.summary_report, "summary_report");
  }, [overallLevel]);

    const isDemo = JSON.parse(localStorage.getItem("Demo_check") ?? "false");

    const summary_demo = `
<p>The month-on-month insight reveals steady growth in team engagement, productivity, and happiness, with a natural dip in December due to the holiday season. This aligns with the general slowdown during year-end festivities when team members take well-deserved breaks, reflecting the importance of work-life balance and rejuvenation.</p>

<p>At the start of this year, however, the indices show a strong rebound, demonstrating SOULSARA’s effectiveness in supporting teams as they re-align with organizational goals. The engagement, productivity, and happiness indices all exhibit significant growth, reaching their highest levels yet.</p>

<h5 style="font-size: 14px;font-weight: bold;color: #2e3191;margin-bottom: 8px;">Looking Ahead: A Promising Year with SOULSARA</h5>

<p>As we move forward, SOULSARA continues its mission to create holistic workplace wellness experiences. The months ahead will introduce advanced tools for real-time team wellbeing insights, personalized support modules, and interactive programs to keep employees engaged and thriving. Together, we aim to make this year one of unprecedented growth and fulfillment for organizations and their people.
</p>

<p>Engagement levels are at an impressive 70%, reflecting active participation and connection among team members. Productivity has significantly enhanced, with tasks being completed more efficiently and collaboratively. Happiness levels have steadily risen, indicating a healthier balance between personal satisfaction and professional fulfillment. These positive outcomes highlight how SOULSARA’s consistent interventions have fostered a supportive environment where individuals and teams can mentally and professionally thrive.</p>
`;

  return (
    <div className={styles.white_bg_wrapper}>
      <div className={styles.info_title}>
        <Text className={styles.title}>Overview</Text>
        <Text className={styles.subtitle}>Based on this month's result</Text>
      </div>
      <div className={styles.graph_wrapper}>
        <>
          <div className={styles.graph_info}>
            <div className={styles.info_txt}>
              <Text className={styles.title}>Wellness Index</Text>
              <div className={styles.subtitle}>
                <Image src="/img/new/wellness_icon.svg" preview={false} />
                <Text className={styles.title}>
                  {overallLevel?.wellnessLevel?.toFixed(1) ?? 0}/8
                </Text>
              </div>
            </div>
            <div className={styles.info_txt}>
              <Text className={styles.title}>Happiness Index</Text>
              <div className={styles.subtitle}>
                <Image src="/img/Happiness.svg" preview={false} />
                <Text className={styles.title}>
                  {overallLevel?.happinessLevel?.toFixed(1) ?? 0}/8
                </Text>
              </div>
            </div>
            <div className={styles.info_txt}>
              <Text className={styles.title}>Engagement</Text>
              <div className={styles.subtitle}>
                <Image src="/img/new/engagement_icon.svg" preview={false} />
                <Text className={styles.title}>
                  {overallLevel?.wpengagement_percentage?.toFixed(0) ?? 0}%
                </Text>
              </div>
            </div>
          </div>
          <div className={styles.Progress_graph_wrapper}>
            <div className={styles.graph}>
              <Progress
                strokeColor={"#9EC655"}
                trailColor="#FDECED"
                className={styles.circleOne}
                size={109}
                strokeWidth={10}
                type="circle"
                percent={overallLevel?.wpengagement_percentage ?? 0}
                showInfo={false}
              />
              <Progress
                strokeColor={"#EF8734"}
                trailColor="#FDECED"
                className={styles.circleOne}
                size={160}
                strokeWidth={8}
                type="circle"
                percent={
                  overallLevel?.happinessLevel
                    ? overallLevel?.happinessLevel?.toFixed(1) * 10
                    : 0
                }
                showInfo={false}
              />
              <Progress
                strokeColor={"#b21e49"}
                trailColor="#FDECED"
                className={styles.circleOne}
                strokeWidth={6}
                size={205}
                type="circle"
                percent={
                  overallLevel?.wellnessLevel
                    ? overallLevel?.wellnessLevel?.toFixed(1) * 10
                    : 0
                }
                showInfo={false}
              />
            </div>
          </div>
        </>
      </div>

      <div className={styles.summaryBox}>
        <Text className={styles.title}>Summary</Text>
        <div
          className={styles.subtitle}
          dangerouslySetInnerHTML={{ __html: isDemo ? summary_demo : overallLevel?.summary_report }}
        ></div>
      </div>

      {/* {overallLevel?.summary_report ===
      "Users not participate for wellness on this month" ? (
        <></>
      ) : (
        
      )} */}
    </div>
  );
}

export default OverallResult;
